<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="商家状态">
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.name" placeholder="商家名称"></el-input></el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    
    <!--添加商家-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/supply/supply/add'">添加学校</el-button>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small"  :data="tableData" border style="width: 100%" v-loading="loading">
             <el-table-column prop="supply_id" label="商家ID"></el-table-column>
            <el-table-column prop="name" label="商家名称"></el-table-column>
            <el-table-column prop="user_id" label="关联用户ID" width="150"></el-table-column>
            <el-table-column label="账号" width="150" >
              <template slot-scope="scope">
              <span v-if="scope.row.shop_user">{{scope.row.shop_user.user_name}}</span>
            </template>	
            </el-table-column>
            <el-table-column label="商家等级">
              <template slot-scope="scope">
              <span>{{scope.row.kmd_grade.name}}</span>
            </template>	
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="150"></el-table-column>
            <el-table-column prop="is_default" label="是否默认">
                <template slot-scope="scope">
                  <el-switch
                    @change="setSupplyDefault(scope.row)"
                    v-model="scope.row.is_default"
                    active-color="#13ce66"
                    inactive-color="#c0c4cc">
                  </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="product_num" label="商品数量"></el-table-column>
            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small"
                v-auth="'/plus/supply/supply/edit'">编辑</el-button>
                 <el-button @click="campusClick(scope.row)" type="text" size="small"
                v-auth="'/plus/campus/index/index'">校区</el-button>
                <el-button @click="serviceClick(scope.row)" type="text" size="small"
                v-auth="'/plus/school_servicex/index'">奶茶品牌</el-button>
                <el-button @click="qkdClick(scope.row)" type="text" size="small"
                v-auth="'/plus/school_servicex/index'">快递类型</el-button>
                 <!-- <el-button @click="coachClick(scope.row)" type="text" size="small"
                v-auth="'/plus/coach_coach/index'">兼职</el-button>
                  <el-button @click="certificate(scope.row)" type="text" size="small"
                v-auth="'/plus/certificate_certificate/index'">证书</el-button>
                  <el-button @click="courseClick(scope.row)" type="text" size="small"
                v-auth="'/plus/course_course/index'">就业课程</el-button> -->
                <!-- <el-button @click="jumpClick(scope.row)" type="text" size="small"
                v-auth="'/plus/supply/supply/delete'">门店</el-button> -->
                <el-button @click="deleteClick(scope.row)" v-auth="'/plus/supply/supply/delete'" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SupplyApi from '@/api/supply.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      supply_id:0,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['禁用', '启用']
    };
  },
  created() {
 
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      SupplyApi.supplyList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加活动*/
    addClick() {
      this.$router.push('/plus/supply/supply/add');
    },
    jumpClick(e){
      this.$router.push({
          path: '/store/index',
          query: {
            supply_id: e.supply_id
          }
        });
    },

    /*编辑活动*/
    editClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/supply/supply/edit',
        query: {
          supply_id: supply_id
        }
      });
    },
    campusClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/campus/index/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    serviceClick(row){
       let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/school_servicex/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    qkdClick(row){
       let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/qkd_type/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    coachClick(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/coach_coach/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    courseClick(row){
       let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/course_course/index',
        query: {
          supply_id: supply_id
        }
      });
    },
    certificate(row) {
      let supply_id = row.supply_id;
      this.$router.push({
        path: '/plus/certificate_certificate/index',
        query: {
          supply_id: supply_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          SupplyApi.delSupply(
            {
              supply_id: row.supply_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '商家删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /* 
    *设置默认供应商
    */
    setSupplyDefault(item){
      let self = this;
      let form = {
        'supply_id':item.supply_id,
        'is_default':item.is_default,
        'operation':'setdefault',
      }
      SupplyApi.saveSupply(form, true)
      .then(data => {
        self.loading = false;
        
        if (data.code == 1) {
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
          self.getTableList();
        } else {
          self.loading = false;
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/index.vue